module.exports = __webpack_public_path__ + "img/x_foximaxi80.16f423fb.jpg";